@if (tooltipHtml()) {
    <div truelearnWebTooltip [tooltipHtml]="tooltipHtml()">
        <ng-container *ngTemplateOutlet="hasSubmenu() ? submenuAnchor : regularAnchor"></ng-container>
    </div>
} @else {
    <ng-container *ngTemplateOutlet="hasSubmenu() ? submenuAnchor : regularAnchor"></ng-container>
}

@if (hasSubmenu()) {
    <div [@slideDownUp]="submenuExpanded() ? 'expanded' : 'collapsed'">
        <ng-content></ng-content>
    </div>
}

<ng-template #submenuAnchor>
    <a
        href="#"
        role="button"
        (click)="$event.preventDefault(); navItemClick.emit()"
        [class]="
            'nav-item nav-link d-flex flex-nowrap align-items-center text-decoration-none py-3 w-100 ' + customClass()
        "
        [attr.aria-label]="ariaLabel()"
        [attr.aria-expanded]="ariaExpanded() ?? null"
    >
        <ng-container *ngTemplateOutlet="iconAndText"></ng-container>
        <i class="fal fa-chevron-down ms-auto" [class.rotate-180]="submenuExpanded()"></i>
    </a>
</ng-template>

<ng-template #regularAnchor>
    <a
        [attr.href]="routerLink() ? null : '#'"
        (click)="!routerLink() && $event.preventDefault(); navItemClick.emit()"
        [class]="
            'nav-item nav-link d-flex flex-nowrap align-items-center text-decoration-none py-3 w-100 ' + customClass()
        "
        [attr.aria-label]="ariaLabel()"
        [routerLink]="routerLink() ?? null"
        routerLinkActive="active"
        [routerLinkActiveOptions]="routerLinkActiveOptions() ?? {exact: false}"
        ariaCurrentWhenActive="page"
    >
        <ng-container *ngTemplateOutlet="iconAndText"></ng-container>
    </a>
</ng-template>

<ng-template #iconAndText>
    @if (imageSrc()) {
        <img [class]="iconClassWithMargin()" [style]="imageStyle()" [src]="imageSrc()" [alt]="imageAlt()" />
    } @else {
        <i [class]="iconClassWithMargin()"></i>
    }
    @if (textTemplate()) {
        <ng-container *ngTemplateOutlet="textTemplate()"></ng-container>
    } @else {
        <span class="text-capitalize">{{ textString() }}</span>
    }
</ng-template>
